import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function TickCircle(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M18.414 9.914l-8 8A1.992 1.992 0 019 18.5a1.99 1.99 0 01-1.414-.586l-3-3a2 2 0 112.828-2.828L9 13.672l6.586-6.586a2 2 0 112.828 2.828M12 0C5.372 0 0 5.372 0 12c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12"
  }));
}

export { TickCircle };
//# sourceMappingURL=TickCircle.js.map